import environmentConfig from "./environment/environment.json";

export const config = environmentConfig;
